import Model from './base';

export default Model.extend( {
	key: 'category',

	defaults: {
		name: '',
		count: 0,
		venueCount: 0,
		eventCount: 0,
	},

	addCount: function( amount = 1, type = 'venue' ) {
		this.set( 'count', this.get( 'count' ) + amount );
		this.set( `${type}Count`, this.get( `${type}Count` ) + amount );
	},

	bindCount: function( type = 'count' ) {
		return [
			`change:${type}`,
			( $elm, options ) => {
				var count = this.get( type ) || 0;

				if ( options.nform ) {
					let nform = options.nform.split( ',' );
					count = `${count} ${count === 1 ? nform[ 0 ] : nform[ 1 ]}`;
				}

				return count;
			},
		];
	},

	bindVenueCount: function() {
		return this.bindCount( 'venueCount' );
	},

	bindEventCount: function() {
		return this.bindCount( 'eventCount' );
	},
} );
